<template>
  <div v-if="section && section.blocks">
    <!-- Header -->
    <div class="models__header">
      <h1 class="alternative-page">
        <i class="signature">Our</i>
        <span class="outline" style="--text:'Models'">Models</span>
      </h1>
    </div>

    <!-- Models Blocks -->
    <div class="models__blocks--wrapper">
      <header class="models__blocks-header">
        <p>Please, click on the cards to learn more.</p>
      </header>
      <div class="models__blocks">
        <div
          class="models-block"
          :class="{ 'active': idx == activeModel }"
          v-for="(model, idx) in models"
          @click="open(idx)"
          :key="model.id">
          <VImg :media="model.image" />
          <h6 class="models-block__label">{{ model.name }}</h6>
        </div>
      </div>
    </div>

    <!-- Person Modal -->
    <modal
      name="model"
      width="90%"
      height="85%"
      :maxWidth="850"
      :maxHeight="500"
      :adaptive="true"
      @before-close="activeModel = null">
      <div class="modal-person" v-if="models[activeModel]">
        <button
          class="vm--close"
          @click="close()">
        </button>
        <div class="modal-person">
          <h1>{{ models[activeModel].title }}</h1>
          <div v-html="models[activeModel].content"></div>
        </div>
      </div>
    </modal>
  </div>
  <Loading
    v-else
    :activated="true"
  />
</template>

<script>
import VImg from './../components/VImg'
import Loading from './../components/Loading'

export default {
  name: 'Models',

  components: { VImg, Loading },

  props: [ 'page_content' ],

  computed: {
    models () {
      return this.section.blocks
    }
  },
  
  data () {
    return {
      section: null,
      activeModel: null
    }
  },

  mounted () {
    this.loadSection()
  },

  methods: {
    loadSection () {
      fetch(`/collections/all?view=models`)
        .then(res => res.json()).then(data => {
          if (data.length) {
            this.section = JSON.parse(data)
          }
        })
    },
    open (idx) {
      this.activeModel = idx
      this.$modal.show('model')
    },
    close () {
      this.$modal.hide('model')
    }
  }
}
</script>
